/**
 * Navigation Component
 * 
 * This component renders the main navigation tabs
 * for switching between different sections of the app.
 */

import React from 'react';
import { useApp } from '../../context/AppContext';
import { useTranslations } from '../../context/TranslationsContext';

const Navigation = () => {
  const { state, actions } = useApp();
  const { translations } = useTranslations();
  const t = translations[state.currentLanguage];

  if (!state.isAuthenticated) {
    return null;
  }

  const tabs = ['dashboard', 'orders', 'retrieval', 'customers', 'whatsapp', 'calculator', 'services', 'settings'];

  return (
    <nav className="app-nav">
      <div className="nav-tabs">
        {tabs.map(tab => (
          <button
            key={tab}
            onClick={() => actions.setActiveTab(tab)}
            className={`nav-tab ${state.activeTab === tab ? 'active' : ''}`}
          >
            {t[tab]}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;
